import { httpClient } from '../httpClient';
import {
  IDialogueTone,
  PaginatedResponse,
  DialogueToneQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户对话音色 API 模块
 * 处理用户对话音色查询操作
 */
export class DialogueToneApi {
  /**
   * 获取对话音色分页列表（POST，强类型）
   */
  async dialogueTonePageList(queryData: PaginationQuery<DialogueToneQuery>): Promise<PaginatedResponse<IDialogueTone>> {
    return httpClient.post<PaginatedResponse<IDialogueTone>>('/user/dialogueTones/page', queryData);
  }
}

// 导出单例实例
export const dialogueToneApi = new DialogueToneApi();